// import { cookies as getCookies } from "next/headers";

// const API_BASE_URL = "https://wagerd-nine.vercel.app";
const API_BASE_URL = process.env.REACT_APP_API_URL;
/**
 * Handle user signup
 * @param {Object} formData - User signup data
 *  * @param {string} referralId - UUID of the referral
 * @param {boolean} isapprove - Approval status
 */
export async function signup(formData) {
  const rawFormData = {
    email: formData.email,
    password: formData.password,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rawFormData),
    });

    const data = await response.json();

    if (!response.ok) {
      return { error: data.message || "Signup failed" };
    }

    return { success: true, user: data.user };
  } catch (error) {
    console.error("Signup error:", error);
    return { error: error.message || "An error occurred during signup" };
  }
}

/**
 * Handle user login
 * @param {Object} formData - User login credentials
 */
export async function login(formData) {
  const rawFormData = {
    email: formData.email,
    password: formData.password,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rawFormData),
    });

    const data = await response.json();

    if (!response.ok) {
      return { error: data.message || "Login failed" };
    }
    // const cookies = await getCookies();
    // cookies.set("token", data.user.token, {
    //   httpOnly: true,
    //   secure: false,
    //   sameSite: "lax",
    //   maxAge: 60 * 60 * 24 * 30,
    //   path: "/",
    // });
    localStorage.setItem("token", data.user.token);

    return { success: true, user: data.user };
  } catch (error) {
    console.error("Login error:", error);
    return { error: error.message || "An error occurred during login" };
  }
}

/**
 * Handle user logout
 */
export async function logout() {
  try {
    // const cookieStore = await getCookies();
    // cookieStore.delete("token");
    localStorage.removeItem("token");

    return { success: true };
  } catch (error) {
    console.error("Logout error:", error);
    return { error: error.message || "An error occurred during logout" };
  }
}

export async function getAllUSDTReferral(
  page = 1,
  limit = 20,
  search = "",
  activeTab = "pending"
) {
  try {
    // const cookieStore = await getCookies();
    // const token = cookieStore.get("token")?.value;
    const token = localStorage.getItem("token");

    if (!token) {
      throw new Error("No authentication token found");
    }
    const response = await fetch(
      `${API_BASE_URL}/usdtReferral?page=${page}&limit=${limit}&search=${encodeURIComponent(
        search
      )}&status=${activeTab}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        cache: "no-store", // Important for always fresh data
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch orders");
    }

    return await response.json();
  } catch (error) {
    console.error("Fetch orders error:", error);
    throw error; // Re-throw to handle in the UI
  }
}

export async function updateReferralUsdtApproval(referralId, isapprove) {
  try {
    // const cookieStore = await getCookies();
    // const token = cookieStore.get("token")?.value;
    const token = localStorage.getItem("token");

    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(
      `${API_BASE_URL}/usdtUpdateapprove`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ referralId, isApprove: isapprove }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to update referral");
    }

    return { success: true, referral: data.referral };
  } catch (error) {
    console.error("Update referral error:", error);
    return {
      error: error.message || "An error occurred while updating referral",
    };
  }
}
